/* hm-image-defer.js — Noom LP (R4, 14.09.2026): images rendered by snippets/hm-image.liquid with `defer: true` carry
   data-src/data-srcset instead of src/srcset (thumbnails, further slides, tab galleries, avatars — ~60 KB that used to share the
   slow-4G link with the hero image before LCP). They get their URLs when the hero has loaded (LCP behind us), on the first
   interaction (touch, pointer, wheel, key, scroll), or 4 s after DOMContentLoaded — whichever comes first. loading="lazy" still
   decides which of them the browser actually fetches. No layout change: width/height attributes were there all along. */
(function () {
  'use strict';
  var done = false;
  function hydrateWithin(root) {
    var imgs = root.querySelectorAll('img[data-hm-defer]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.dataset.srcset) img.setAttribute('srcset', img.dataset.srcset);
      if (img.dataset.src) img.setAttribute('src', img.dataset.src);
      img.removeAttribute('data-hm-defer');
    }
  }
  function hydrate() {
    if (done) return;
    done = true;
    hydrateWithin(document);
  }
  // Codex C2 (14.09): the theme editor re-renders a section (text/image change, added section) after the page has been
  // hydrated once — its fresh DOM carries data-src again. Hydrate just that section on the editor's event, whatever `done`
  // says; no re-initialisation of the page and no DOM observer (the event only fires inside the editor).
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelectorAll) hydrateWithin(event.target);
  });
  ['touchstart', 'pointerdown', 'wheel', 'keydown', 'scroll'].forEach(function (ev) {
    window.addEventListener(ev, hydrate, { once: true, passive: true, capture: true });
  });
  var hero = document.querySelector('img[fetchpriority="high"]');
  if (hero) {
    if (hero.complete) setTimeout(hydrate, 400);
    else hero.addEventListener('load', function () { setTimeout(hydrate, 400); }, { once: true });
  }
  window.addEventListener('load', function () { setTimeout(hydrate, 300); }, { once: true });
  setTimeout(hydrate, 4000);
})();
